<template>
  <Drawer
    :title="showName"
    v-model="treeStatus"
    width="720"
    :mask-closable="false"
    :styles="drawerStyles"
  >
    <!--<div v-if="treeData.length === 0">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>-->
    <div>
      <Tree :data="treeData" show-checkbox multiple></Tree>
      <div class="drawer-footer">
        <Button style="margin-right: 8px" @click="cancel">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="ok">保存</Button>
      </div>
    </div>
  </Drawer>
</template>

<script>
  export default {
    name: 'UserRoleTree',
    props: {
      currentItem: {
        type: Object,
        default: () => {
        }
      }
    },
    data () {
      return {
        treeStatus: false,
        treeData: []
        // treeData: [
        //   {
        //     title: 'parent 1',
        //     expand: true,
        //     selected: true,
        //     children: [
        //       {
        //         title: 'parent 1-1',
        //         expand: true,
        //         children: [
        //           {
        //             title: 'leaf 1-1-1',
        //             disabled: true
        //           },
        //           {
        //             title: 'leaf 1-1-2'
        //           }
        //         ]
        //       },
        //       {
        //         title: 'parent 1-2',
        //         expand: true,
        //         children: [
        //           {
        //             title: 'leaf 1-2-1',
        //             checked: true
        //           },
        //           {
        //             title: 'leaf 1-2-1'
        //           }
        //         ]
        //       }
        //     ]
        //   }
        // ]
      }
    },
    methods: {
      cancel () {
        this.treeStatus = false
      },
      async ok () {
        let diffTree = this.$utils.diffUserRoleTree(this.treeData)
        if (diffTree.length === 0) {
          this.cancel()
          return false
        }
        let query = {
          userId: this.currentItem.id,
          platCode: this.currentItem.platCode,
          roleList: diffTree.map(it => {
            return {
              roleId: it.id,
              status: it.checked
            }
          })
        }
        this.submitLoading = true
        let { succ } = await this.$http.updateUserRole(query)
        this.submitLoading = false
        if (succ) {
          this.$Message.success('更新用户权限成功!')
          this.cancel()
        }
      },
      async getPlatTree () {
        let { id, platCode, userName } = this.currentItem
        let { data } = await this.$http.getUserRoleTree({ id, platCode })
        data = data.length === 0 ? [] : data
        let rootTree = this.$utils.getUserRoleTree(userName, data)
        this.treeData = rootTree
      }
    },
    computed: {
      showName () {
        if (this.currentItem) {
          return this.currentItem.userName
        }
        return ''
      }
    },
    watch: {
      currentItem: {
        handler (c) {
          this.getPlatTree()
        },
        deep: true
      }
    }
  }
</script>

<style scoped lang="less">
  .drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
